import React from 'react'
import { GlobalDataState } from '../../Context'
import { useState } from 'react';

const FilterFavourites = () => {
  
    const {
        state:{stack},
    }=GlobalDataState();
    const {setSorted}=GlobalDataState();
    //   const [sorted,setSorted]=GlobalDataState();
     function IncreasingSort(id){
        //console.log(id)
        
        
        if(id==="01"){
            const copyData=[...stack];
            copyData.sort((a,b)=>parseFloat(a.vote_average)-parseFloat(b.vote_average))
            setSorted(copyData);
        }
        else if(id==="02"){
            const copyData=[...stack];
            copyData.sort((a,b)=>parseFloat(b.vote_average)-parseFloat(a.vote_average))
            setSorted(copyData);  
        }else if(id==="00"){
            const copyData=[...stack];
            copyData.sort((a,b)=>parseFloat(b.vote_average)-parseFloat(a.vote_average))
            setSorted(copyData); 
        }
     };
    
  return (
    <div style={{display:'flex',justifyContent:'center'}}>
        <div>
            {/* <select>
                <option>Filter</option>
                <option value='01'>BY RATING</option>
                <option value='02'>BY DATE</option>
            </select> */}
        </div>
        <div>
            {/* <select onChange={(e)=>IncreasingSort(e.target.value)}>
                <option value="00">ORDER</option>
                <option value="01">INCREASING</option>
                <option value='02'>DECREASING</option>
            </select> */}
            <button value="01" onClick={(e)=>IncreasingSort(e.target.value)} style={{height:'2rem',width:'7rem',backgroundColor:'gray',borderRadius:'1rem'}}>INCREASING</button>
            <button value="02" onClick={(e)=>IncreasingSort(e.target.value)} style={{height:'2rem',width:'7rem',backgroundColor:'gray',borderRadius:'1rem'}}>DECREASING</button>
        </div>
    </div>
  )
}

export default FilterFavourites